/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditEntryDtoPagedList,
  GetApiV1AuditParams,
  ProblemDetails
} from '.././model';

import { request } from '../../http-client';




export const getApiV1Audit = (
    params?: GetApiV1AuditParams,
 signal?: AbortSignal
) => {
      
      
      return request<AuditEntryDtoPagedList>(
      {url: `/api/v1/audit`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1AuditQueryKey = (params?: GetApiV1AuditParams,) => {
    return [
    `/api/v1/audit`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1AuditQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Audit>>, TError = ProblemDetails>(params?: GetApiV1AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Audit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1AuditQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Audit>>> = ({ signal }) => getApiV1Audit(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Audit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1AuditQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Audit>>>
export type GetApiV1AuditQueryError = ProblemDetails


export function useGetApiV1Audit<TData = Awaited<ReturnType<typeof getApiV1Audit>>, TError = ProblemDetails>(
 params: undefined |  GetApiV1AuditParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Audit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Audit>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Audit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Audit<TData = Awaited<ReturnType<typeof getApiV1Audit>>, TError = ProblemDetails>(
 params?: GetApiV1AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Audit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Audit>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Audit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Audit<TData = Awaited<ReturnType<typeof getApiV1Audit>>, TError = ProblemDetails>(
 params?: GetApiV1AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Audit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Audit<TData = Awaited<ReturnType<typeof getApiV1Audit>>, TError = ProblemDetails>(
 params?: GetApiV1AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Audit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1AuditQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1AuditEntityTypes = (
    
 signal?: AbortSignal
) => {
      
      
      return request<string[]>(
      {url: `/api/v1/audit/entity-types`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1AuditEntityTypesQueryKey = () => {
    return [
    `/api/v1/audit/entity-types`
    ] as const;
    }

    
export const getGetApiV1AuditEntityTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1AuditEntityTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>> = ({ signal }) => getApiV1AuditEntityTypes(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1AuditEntityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>>
export type GetApiV1AuditEntityTypesQueryError = ProblemDetails


export function useGetApiV1AuditEntityTypes<TData = Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1AuditEntityTypes<TData = Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1AuditEntityTypes<TData = Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1AuditEntityTypes<TData = Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1AuditEntityTypes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1AuditEntityTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




